import { createSelector } from 'reselect';
import { experienceSelector } from 'selectors/testTarget/offers/addHighlightPills/experience/experienceSelector';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';
import { ADD_HIGHLIGHT_PILLS } from 'constants/TestTarget';

const showAddHighlightPillsSelector = createSelector(isTestTargetReadySelector, experienceSelector, (testReady, experience) => ({
    challengerOne: testReady && experience === ADD_HIGHLIGHT_PILLS.CHALLENGER_ONE,
    challengerTwo: testReady && experience === ADD_HIGHLIGHT_PILLS.CHALLENGER_TWO
}));

export { showAddHighlightPillsSelector };
